module.exports = __webpack_public_path__ + "static/TeachSDLogoColor-a724ffcbf8f1a95678884d802aae2304.png";